<template>
  <div class="Orders2Skeleton" aria-busy="true" aria-label="Cargando seguimiento">
    <section class="seccion-gris">
      <div class="container">
        <div class="bloque breadcrumbs">
          <div class="skeleton-line skeleton-line--sm" style="width: 180px;"></div>
        </div>

        <div class="bloque skeleton-card">
          <div class="row resumen-orden">
            <div class="col-md-6">
              <div class="skeleton-line skeleton-line--lg" style="width: 70%; max-width: 320px;"></div>
            </div>
            <div class="col-md-6 skeleton-align-end">
              <div class="skeleton-line skeleton-line--md" style="width: 140px;"></div>
              <div class="skeleton-line skeleton-line--sm" style="width: 220px; margin-top: 10px;"></div>
            </div>
          </div>

          <div class="row despacho skeleton-despacho">
            <div class="col-lg-9">
              <div class="skeleton-line skeleton-line--md skeleton-center" style="width: 100px; margin: 0 auto 28px;"></div>

              <div class="skeleton-tracking">
                <div class="skeleton-tracking-line"></div>
                <div
                  v-for="n in 5"
                  :key="'track-' + n"
                  class="skeleton-tracking-step"
                >
                  <div class="skeleton-circle"></div>
                  <div class="skeleton-line skeleton-line--xs" :style="{ width: n === 1 ? '90px' : '70px' }"></div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 skeleton-actions">
              <div class="skeleton-btn"></div>
              <div class="skeleton-btn"></div>
            </div>

            <div class="col-lg-9 skeleton-product-block">
              <div class="skeleton-line skeleton-line--md" style="width: 200px; margin-bottom: 20px;"></div>
              <div class="skeleton-product">
                <div class="skeleton-image"></div>
                <div class="skeleton-product-text">
                  <div class="skeleton-line skeleton-line--md" style="width: 85%;"></div>
                  <div class="skeleton-line skeleton-line--sm" style="width: 100px; margin-top: 12px;"></div>
                  <div class="skeleton-line skeleton-line--xs" style="width: 130px; margin-top: 8px;"></div>
                  <div class="skeleton-line skeleton-line--sm" style="width: 90px; margin-top: 12px;"></div>
                  <div class="skeleton-line skeleton-line--sm" style="width: 140px; margin-top: 8px;"></div>
                </div>
              </div>
            </div>
          </div>

          <hr class="separador" />

          <div class="skeleton-dispatch">
            <div class="skeleton-line skeleton-line--md" style="width: 210px; margin-bottom: 24px;"></div>
            <div
              v-for="n in 6"
              :key="'row-' + n"
              class="skeleton-dispatch-row"
            >
              <div class="skeleton-line skeleton-line--sm" :style="{ width: n === 6 ? '160px' : '140px' }"></div>
              <div
                class="skeleton-line skeleton-line--sm"
                :style="{ width: n === 5 || n === 6 ? '55%' : '35%', maxWidth: n === 5 || n === 6 ? '320px' : '200px' }"
              ></div>
            </div>
          </div>

          <hr class="separador" />

          <div class="skeleton-line skeleton-line--md" style="width: 120px; margin-top: 8px;"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Orders2Skeleton"
};
</script>

<style lang="scss" src="./Orders2Skeleton.scss"></style>
